import { Content } from '@prismicio/client';
import { Simplify } from '../../../../../../prismicio-types';
import styles from './ourClientsCards.module.scss';
import { OptimizedPrismicImage } from '@/components';
import { HeaderIcons } from '@/assets';

interface OurClientsCardsProps {
  data: Simplify<Content.HeroSliceOurClientsPrimary>;
  isVisible: boolean;
}

export const OurClientsCards = ({ data, isVisible }: OurClientsCardsProps) => {
  const isVisibleStyles = isVisible ? styles.isVisible : '';
  return (
    <article className={styles.cards_content}>
      <div className={`${styles.column} ${styles.column_1}`}>
        <div className={`${styles.gradient_plate} ${isVisibleStyles}`}>
          {data.gradient_plate_text}
        </div>
        <div className={`${styles.image_wrapper} ${isVisibleStyles}`}>
          <OptimizedPrismicImage
            field={data.first_image}
            className={styles.image}
            quality={100}
          />
        </div>
        <ul className={`${styles.plate} ${isVisibleStyles}`}>
          <li className={styles.plate_item}>
            <HeaderIcons icon={data.first_dark_plate_icon} />
            <span>{data.first_dark_plate_text}</span>
          </li>
        </ul>
      </div>
      <div className={`${styles.column} ${styles.column_2}`}>
        <ul className={`${styles.plate} ${isVisibleStyles}`}>
          {data.second_dark_plate.map((item) => (
            <li className={styles.plate_item} key={item.text}>
              <HeaderIcons icon={item.icon} />
              <span>{item.text}</span>
            </li>
          ))}
        </ul>
        <div className={`${styles.image_wrapper} ${isVisibleStyles}`}>
          <OptimizedPrismicImage
            field={data.second_image}
            className={styles.image}
            quality={100}
          />
        </div>
      </div>
    </article>
  );
};
